export enum JobErrorMessage {
  ErrorOccurred = "An error occurred. Please try again later!",
  JobNumberNotExist = "This Job number does not exist",
  AlreadyAssigned = "This Job is already assigned to Driver",
  AlreadySummitted = "This Job is already summitted",
  RequireInput = "Please enter a Job number",
  EverCompleted = "This job was at one point completed. Based on company settings, it can't be assigned."
}

export enum GlobalFindSkillMessage {
  Warning = "This driver doesn't have the necessary skills, are you sure you'd like to assign it to them?",
  Prevent = "This driver doesn't have the necessary skills and assignment has been blocked."
}
